/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.MembershipApi = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        OrderCommentsService: function () {
            return function (headers) {
                var service = {
                    createOrderComment: function (createOrderCommentRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{orderId}/comments', createOrderCommentRequest, headers);
                    },
                    deleteOrderComment: function (deleteOrderCommentRequest) {
                        return httpClient.invoke('DELETE', '/v1/orders/{orderId}/comments/{id}', deleteOrderCommentRequest, headers);
                    },
                    getOrderComment: function (getOrderCommentRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{orderId}/comments/{id}', getOrderCommentRequest, headers);
                    },
                    listOrderComments: function (listOrderCommentsRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{orderId}/comments', listOrderCommentsRequest, headers);
                    },
                    updateOrderComment: function (updateOrderCommentRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{orderId}/comments/{id}', updateOrderCommentRequest, headers);
                    }
                };
                service.createOrderComment.__http_method = 'POST';
                service.createOrderComment.__http_url = '/v1/orders/{orderId}/comments';
                service.deleteOrderComment.__http_method = 'DELETE';
                service.deleteOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                service.getOrderComment.__http_method = 'GET';
                service.getOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                service.listOrderComments.__http_method = 'GET';
                service.listOrderComments.__http_url = '/v1/orders/{orderId}/comments';
                service.updateOrderComment.__http_method = 'PUT';
                service.updateOrderComment.__http_url = '/v1/orders/{orderId}/comments/{id}';
                return service;
            };
        },
        OrdersService: function () {
            return function (headers) {
                var service = {
                    cancelOrder: function (cancelOrderRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/cancel', cancelOrderRequest, headers);
                    },
                    getCurrentMemberOrders: function (getCurrentMemberOrdersRequest) {
                        return httpClient.invoke('GET', '/v1/orders/my-orders', getCurrentMemberOrdersRequest, headers);
                    },
                    getOrder: function (getOrderRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{id}', getOrderRequest, headers);
                    },
                    getOrdersStats: function (getOrdersStatsRequest) {
                        return httpClient.invoke('GET', '/v1/orders/stats', getOrdersStatsRequest, headers);
                    },
                    getPricePreview: function (getPricePreviewRequest) {
                        return httpClient.invoke('GET', '/v1/orders/price-preview', getPricePreviewRequest, headers);
                    },
                    getPurchasePreview: function (getPurchasePreviewRequest) {
                        return httpClient.invoke('POST', '/v1/orders/preview', getPurchasePreviewRequest, headers);
                    },
                    getSuspendableStatus: function (getSuspendableStatusRequest) {
                        return httpClient.invoke('GET', '/v1/orders/{id}/suspendable-status', getSuspendableStatusRequest, headers);
                    },
                    listOrders: function (listOrdersRequest) {
                        return httpClient.invoke('GET', '/v1/orders', listOrdersRequest, headers);
                    },
                    markOfflineOrderAsPaid: function (markOfflineOrderAsPaidRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/mark-as-paid', markOfflineOrderAsPaidRequest, headers);
                    },
                    purchasePlan: function (purchasePlanRequest) {
                        return httpClient.invoke('POST', '/v1/orders', purchasePlanRequest, headers);
                    },
                    purchasePlanOffline: function (purchasePlanOfflineRequest) {
                        return httpClient.invoke('POST', '/v1/orders/offline', purchasePlanOfflineRequest, headers);
                    },
                    resume: function (resumeOrderRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/resume', resumeOrderRequest, headers);
                    },
                    suspend: function (suspendOrderRequest) {
                        return httpClient.invoke('POST', '/v1/orders/{id}/suspend', suspendOrderRequest, headers);
                    },
                    updateValidFrom: function (updateValidFromRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{id}/valid-from', updateValidFromRequest, headers);
                    },
                    updateValidUntil: function (updateValidUntilRequest) {
                        return httpClient.invoke('PUT', '/v1/orders/{id}/valid-until', updateValidUntilRequest, headers);
                    }
                };
                service.cancelOrder.__http_method = 'POST';
                service.cancelOrder.__http_url = '/v1/orders/{id}/cancel';
                service.getCurrentMemberOrders.__http_method = 'GET';
                service.getCurrentMemberOrders.__http_url = '/v1/orders/my-orders';
                service.getOrder.__http_method = 'GET';
                service.getOrder.__http_url = '/v1/orders/{id}';
                service.getOrdersStats.__http_method = 'GET';
                service.getOrdersStats.__http_url = '/v1/orders/stats';
                service.getPricePreview.__http_method = 'GET';
                service.getPricePreview.__http_url = '/v1/orders/price-preview';
                service.getPurchasePreview.__http_method = 'POST';
                service.getPurchasePreview.__http_url = '/v1/orders/preview';
                service.getSuspendableStatus.__http_method = 'GET';
                service.getSuspendableStatus.__http_url = '/v1/orders/{id}/suspendable-status';
                service.listOrders.__http_method = 'GET';
                service.listOrders.__http_url = '/v1/orders';
                service.markOfflineOrderAsPaid.__http_method = 'POST';
                service.markOfflineOrderAsPaid.__http_url = '/v1/orders/{id}/mark-as-paid';
                service.purchasePlan.__http_method = 'POST';
                service.purchasePlan.__http_url = '/v1/orders';
                service.purchasePlanOffline.__http_method = 'POST';
                service.purchasePlanOffline.__http_url = '/v1/orders/offline';
                service.resume.__http_method = 'POST';
                service.resume.__http_url = '/v1/orders/{id}/resume';
                service.suspend.__http_method = 'POST';
                service.suspend.__http_url = '/v1/orders/{id}/suspend';
                service.updateValidFrom.__http_method = 'PUT';
                service.updateValidFrom.__http_url = '/v1/orders/{id}/valid-from';
                service.updateValidUntil.__http_method = 'PUT';
                service.updateValidUntil.__http_url = '/v1/orders/{id}/valid-until';
                return service;
            };
        },
        PlansService: function () {
            return function (headers) {
                var service = {
                    archivePlan: function (v1PlansArchivePlanRequest) {
                        return httpClient.invoke('POST', '/v1/plans/{id}/archive', v1PlansArchivePlanRequest, headers);
                    },
                    arrangePlans: function (v1PlansArrangePlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/arrange', v1PlansArrangePlansRequest, headers);
                    },
                    countPublicPlans: function (countPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/count', countPublicPlansRequest, headers);
                    },
                    createPlan: function (v1PlansCreatePlanRequest) {
                        return httpClient.invoke('POST', '/v1/plans', v1PlansCreatePlanRequest, headers);
                    },
                    getPlan: function (v1PlansGetPlanRequest) {
                        return httpClient.invoke('GET', '/v1/plans/{id}', v1PlansGetPlanRequest, headers);
                    },
                    getPlansStats: function (getPlansStatsRequest) {
                        return httpClient.invoke('GET', '/v1/plans/stats', getPlansStatsRequest, headers);
                    },
                    listPlans: function (v1PlansListPlansRequest) {
                        return httpClient.invoke('GET', '/v1/plans', v1PlansListPlansRequest, headers);
                    },
                    listPublicPlans: function (v1PlansListPublicPlansRequest) {
                        return httpClient.invoke('GET', '/v1/plans/public', v1PlansListPublicPlansRequest, headers);
                    },
                    makeNoPlanPrimary: function (makeNoPlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/clear-primary', makeNoPlanPrimaryRequest, headers);
                    },
                    makePlanPrimary: function (v1PlansMakePlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/{id}/make-primary', v1PlansMakePlanPrimaryRequest, headers);
                    },
                    queryPublicPlans: function (v1PlansQueryPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/query', v1PlansQueryPublicPlansRequest, headers);
                    },
                    setPlanVisibility: function (v1PlansSetPlanVisibilityRequest) {
                        return httpClient.invoke('PUT', '/v1/plans/{id}/visibility', v1PlansSetPlanVisibilityRequest, headers);
                    },
                    updatePlan: function (v1PlansUpdatePlanRequest) {
                        return httpClient.invoke('PATCH', '/v1/plans/{id}', v1PlansUpdatePlanRequest, headers);
                    }
                };
                service.archivePlan.__http_method = 'POST';
                service.archivePlan.__http_url = '/v1/plans/{id}/archive';
                service.arrangePlans.__http_method = 'POST';
                service.arrangePlans.__http_url = '/v1/plans/arrange';
                service.countPublicPlans.__http_method = 'POST';
                service.countPublicPlans.__http_url = '/v1/plans/public/count';
                service.createPlan.__http_method = 'POST';
                service.createPlan.__http_url = '/v1/plans';
                service.getPlan.__http_method = 'GET';
                service.getPlan.__http_url = '/v1/plans/{id}';
                service.getPlansStats.__http_method = 'GET';
                service.getPlansStats.__http_url = '/v1/plans/stats';
                service.listPlans.__http_method = 'GET';
                service.listPlans.__http_url = '/v1/plans';
                service.listPublicPlans.__http_method = 'GET';
                service.listPublicPlans.__http_url = '/v1/plans/public';
                service.makeNoPlanPrimary.__http_method = 'POST';
                service.makeNoPlanPrimary.__http_url = '/v1/plans/clear-primary';
                service.makePlanPrimary.__http_method = 'POST';
                service.makePlanPrimary.__http_url = '/v1/plans/{id}/make-primary';
                service.queryPublicPlans.__http_method = 'POST';
                service.queryPublicPlans.__http_url = '/v1/plans/public/query';
                service.setPlanVisibility.__http_method = 'PUT';
                service.setPlanVisibility.__http_url = '/v1/plans/{id}/visibility';
                service.updatePlan.__http_method = 'PATCH';
                service.updatePlan.__http_url = '/v1/plans/{id}';
                return service;
            };
        },
        PlansServiceV2: function () {
            return function (headers) {
                var service = {
                    archivePlan: function (v2PlansArchivePlanRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{id}/archive', v2PlansArchivePlanRequest, headers);
                    },
                    arrangePlans: function (v2PlansArrangePlansRequest) {
                        return httpClient.invoke('POST', '/v2/plans/arrange', v2PlansArrangePlansRequest, headers);
                    },
                    clearPrimary: function (clearPrimaryRequest) {
                        return httpClient.invoke('POST', '/v2/plans/clear-primary', clearPrimaryRequest, headers);
                    },
                    createPlan: function (v2PlansCreatePlanRequest) {
                        return httpClient.invoke('POST', '/v2/plans', v2PlansCreatePlanRequest, headers);
                    },
                    getPlan: function (v2PlansGetPlanRequest) {
                        return httpClient.invoke('GET', '/v2/plans/{id}', v2PlansGetPlanRequest, headers);
                    },
                    getPlanStats: function (getPlanStatsRequest) {
                        return httpClient.invoke('GET', '/v2/plans/stats', getPlanStatsRequest, headers);
                    },
                    listPlans: function (v2PlansListPlansRequest) {
                        return httpClient.invoke('GET', '/v2/plans', v2PlansListPlansRequest, headers);
                    },
                    listPublicPlans: function (v2PlansListPublicPlansRequest) {
                        return httpClient.invoke('GET', '/v2/plans/public', v2PlansListPublicPlansRequest, headers);
                    },
                    makePlanPrimary: function (v2PlansMakePlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{id}/make-primary', v2PlansMakePlanPrimaryRequest, headers);
                    },
                    queryPublicPlans: function (v2PlansQueryPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v2/plans/public/query', v2PlansQueryPublicPlansRequest, headers);
                    },
                    setPlanVisibility: function (v2PlansSetPlanVisibilityRequest) {
                        return httpClient.invoke('PUT', '/v2/plans/{id}/visibility', v2PlansSetPlanVisibilityRequest, headers);
                    },
                    updatePlan: function (v2PlansUpdatePlanRequest) {
                        return httpClient.invoke('PATCH', '/v2/plans/{plan.id}', v2PlansUpdatePlanRequest, headers);
                    }
                };
                service.archivePlan.__http_method = 'POST';
                service.archivePlan.__http_url = '/v2/plans/{id}/archive';
                service.arrangePlans.__http_method = 'POST';
                service.arrangePlans.__http_url = '/v2/plans/arrange';
                service.clearPrimary.__http_method = 'POST';
                service.clearPrimary.__http_url = '/v2/plans/clear-primary';
                service.createPlan.__http_method = 'POST';
                service.createPlan.__http_url = '/v2/plans';
                service.getPlan.__http_method = 'GET';
                service.getPlan.__http_url = '/v2/plans/{id}';
                service.getPlanStats.__http_method = 'GET';
                service.getPlanStats.__http_url = '/v2/plans/stats';
                service.listPlans.__http_method = 'GET';
                service.listPlans.__http_url = '/v2/plans';
                service.listPublicPlans.__http_method = 'GET';
                service.listPublicPlans.__http_url = '/v2/plans/public';
                service.makePlanPrimary.__http_method = 'POST';
                service.makePlanPrimary.__http_url = '/v2/plans/{id}/make-primary';
                service.queryPublicPlans.__http_method = 'POST';
                service.queryPublicPlans.__http_url = '/v2/plans/public/query';
                service.setPlanVisibility.__http_method = 'PUT';
                service.setPlanVisibility.__http_url = '/v2/plans/{id}/visibility';
                service.updatePlan.__http_method = 'PATCH';
                service.updatePlan.__http_url = '/v2/plans/{plan.id}';
                return service;
            };
        },
        PremiumService: function () {
            return function (headers) {
                var service = {
                    getPremiumStatus: function (getPremiumStatusRequest) {
                        return httpClient.invoke('GET', '/v1/premium/status', getPremiumStatusRequest, headers);
                    }
                };
                service.getPremiumStatus.__http_method = 'GET';
                service.getPremiumStatus.__http_url = '/v1/premium/status';
                return service;
            };
        },
        ProvisioningService: function () {
            return function (headers) {
                var service = {
                    getStatus: function (getStatusRequest) {
                        return httpClient.invoke('GET', '/v1/provisioning/status', getStatusRequest, headers);
                    }
                };
                service.getStatus.__http_method = 'GET';
                service.getStatus.__http_url = '/v1/provisioning/status';
                return service;
            };
        },
        SettingsService: function () {
            return function (headers) {
                var service = {
                    getSettings: function (getSettingsRequest) {
                        return httpClient.invoke('GET', '/v2/settings', getSettingsRequest, headers);
                    },
                    updateSettings: function (updateSettingsRequest) {
                        return httpClient.invoke('PATCH', '/v2/settings', updateSettingsRequest, headers);
                    }
                };
                service.getSettings.__http_method = 'GET';
                service.getSettings.__http_url = '/v2/settings';
                service.updateSettings.__http_method = 'PATCH';
                service.updateSettings.__http_url = '/v2/settings';
                return service;
            };
        },
        TaxService: function () {
            return function (headers) {
                var service = {
                    getTaxConfig: function (getTaxConfigRequest) {
                        return httpClient.invoke('GET', '/v1/tax/config', getTaxConfigRequest, headers);
                    },
                    setTaxConfig: function (setTaxConfigRequest) {
                        return httpClient.invoke('PATCH', '/v1/tax/config', setTaxConfigRequest, headers);
                    }
                };
                service.getTaxConfig.__http_method = 'GET';
                service.getTaxConfig.__http_url = '/v1/tax/config';
                service.setTaxConfig.__http_method = 'PATCH';
                service.setTaxConfig.__http_url = '/v1/tax/config';
                return service;
            };
        }
    };
};
exports.MembershipApi.__transport = 'http';
__export(require("./types"));
